import PropTypes from "prop-types"
import styled from "styled-components"
import { useT } from "react-polyglot-hooks"
import Icon from "components/icons/icon"
import Typography from "components/styled/Typography"
import { PanoramaHint } from "components/icons/panoramaHint"
import { color } from "helpers/styled"

const Wrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 168px;
  height: 168px;
  padding: 32px 24px;
  border-radius: 50%;
  text-align: center;
  background: ${color("white")};
  pointer-events: none;
  touch-action: none;
  z-index: 99;
`

const StyledIcon = styled(Icon)`
  margin-bottom: 10px;
`

function Hint({ show }) {
  const t = useT()

  return (
    show && (
      <Wrapper>
        <StyledIcon size="xl" Icon={PanoramaHint} />
        <Typography variant="small" color="darkblue">
          {t("car_data.panorama.hint")}
        </Typography>
      </Wrapper>
    )
  )
}

Hint.propTypes = {
  show: PropTypes.bool.isRequired
}

export default Hint
